jQuery(document).ready(function ($) {
    "use strict";

    const loadMoreBtn = $("#load-more-posts");
    const loadMoreContainer = $("#load-more-posts-container");

    if (loadMoreBtn.length) {
        loadMoreBtn.on("click", function () {
            const button = $(this);
            const offset = parseInt(button.data("offset"));

            // Disable button and show loading state
            button.prop("disabled", true).text("Načítání...");

            $.ajax({
                url: ajax_object.ajax_url,
                type: "POST",
                data: {
                    action: "load_more_posts",
                    offset: offset,
                    nonce: ajax_object.nonce,
                },
                success: function (response) {
                    if (response.success && response.data.posts) {
                        // Show container if hidden
                        if (loadMoreContainer.is(":hidden")) {
                            loadMoreContainer.show();
                        }

                        // Append new posts
                        loadMoreContainer.append(response.data.posts);

                        // Update offset for next load
                        const newOffset = offset + 12;
                        button.data("offset", newOffset);

                        // If no more posts, hide button
                        if (!response.data.has_more) {
                            button.hide();
                        } else {
                            button.prop("disabled", false).text("Zobrazit více");
                        }
                    } else {
                        // No more posts
                        button.hide();
                    }
                },
                error: function () {
                    button.prop("disabled", false).text("Zobrazit více");
                    alert("Chyba při načítání článků. Zkuste to prosím znovu.");
                },
            });
        });
    }

    // Category filtering
    $(".headline__tags .tag").on("click", function (e) {
        e.preventDefault();

        const category = $(this).data("category");
        const tags = $(".headline__tags .tag");
        const cards = $(".cards__card");

        // Update active state
        tags.removeClass("active");
        $(this).addClass("active");

        if (category === "all") {
            // Show all cards
            cards.show();
        } else {
            // Filter cards by category
            cards.each(function () {
                const cardCategories = $(this).data("categories");
                if (cardCategories && cardCategories.includes(category)) {
                    $(this).show();
                } else {
                    $(this).hide();
                }
            });
        }
    });
});
